import { IconName } from '@frontend/icons';

export type QuickFilterCardVariant = 'card' | 'compactCard';

export type QuickFilterVariant = QuickFilterCardVariant | 'dropdown';

export enum QuickFilterKey {
  All = 'all',
  Unconfirmed = 'unconfirmed',
  Insurance = 'insurance',
}

export type QuickFilterListItem = {
  key: QuickFilterKey;
  label: string;
  count: number;
  iconName: IconName;
  isActive?: boolean;
  trackingId?: string;
};
